<template>
	<form @submit.prevent="sendForm">
		<v-card v-bind="$attrs">
			<v-card-text>
				<template v-for="input in inputs">
					<component
						v-if="input.component"
						:is="input.component"
						v-model="form[input.name]"
						:key="input.label"
						v-bind="input"
						:errors="errors[input.name]"
					/>
					<smart-input
						v-else
						v-model="form[input.name]"
						:key="input.label"
						v-bind="input"
						:errors="errors[input.name]"
					/>
				</template>

			</v-card-text>
		</v-card>
		<v-card-actions>
			<v-btn :loading="inProgress" color="success" type="input">שלח טופס</v-btn>
		</v-card-actions>
	</form>
</template>

<script>
	import {ref, reactive, computed, watch} from "@vue/composition-api";
	import LaravelErrors from "../../helpers/LaravelErrors";
	import {cloneDeep} from "lodash";
	import {getModule} from "../../store";

	export default {
		name: "form-builder",
		props: {
			inputs: Array,
			// form:Object,
			module: String,
			modelName: String
		},
		setup(props) {
			let baseData = {};
			let inputErrors = {};
			Object.values(props.inputs).forEach((key) => {
				baseData[key.name] = null;
				inputErrors[key.name] = null;
			});
			const form = ref(baseData);
			const errors = ref(inputErrors);
			const inProgress = ref(false);
			return {form, inProgress, errors};
		},
		computed: {
			model() {
				return this.$store.state[this.module][this.modelName];
			}
		},
		methods: {
			async sendForm() {
				this.inProgress = true;
				this.errors = {};
				const isNew = !this.form.id;
				try {
					const response = await this.$store.dispatch(getModule(this.module).types.SAVE, this.form);
					if (isNew) {
						this.$emit("create", response);
					} else {
						this.$emit("update", response);
					}
					this.$emit("save", response);
					this.$notfication.success();
				} catch (error) {
					if (error.response && error.response.status === 422 && error.response.data && error.response.data.errors) {
						this.errors = LaravelErrors.getFirstErrorOnly(error.response.data.errors);
					}
				} finally {
					this.inProgress = false;
				}
			}
		},
		watch: {
			model: {
				immediate: true,
				handler() {
					this.form = cloneDeep(this.model);
				}
			}
		}
	};
</script>
